import { http } from "config/http";
import { MapFilterData, salesFilterData } from "pages/sales-forecast/salesForecastTypes";


export const getSalesForecastData= async (filter: salesFilterData) => {



    try {
        const res: any = await http.post(`get_sales_data`,filter)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getSalesForecastGraphData= async (filter: salesFilterData) => {



    try {
        const res: any = await http.post(`get_sales_graph_data`,filter)
   
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getSalesMapData= async (filter: MapFilterData) => {



    try {
        const res: any = await http.post(`get_sales_map_data`,filter)
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}



export const getHighlights= async (filter: MapFilterData) => {



    try {
        const res: any = await http.post(`get_highlights`, filter)
        return { result: res?.data.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getAllRegionData= async () => {

const selectedState: string[] = []

    try {
        const res: any = await http.get(`get_all_country_state_cities?client_env=${localStorage.getItem("clientName")}${selectedState.length > 0 ? `&selected_states=${selectedState}` : ""}`)
        return { result: res?.data.result }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getSalesPersonData= async () => {

    const city : string = ""
    const sales_manager: string = ""
    
        try {
            const res: any = await http.get(`get_sales_persons_data?client_env=${localStorage.getItem("clientName")}`)
            return { result: res?.data.data }
        } catch (error: any) {
            return { error: error.message }
        }
    }